export default __webpack_public_path__ + "static/media/Comp 2_00003.dab6ef79.png";